<script>
import Layout from '@/Shared/Layout'
export default { layout: Layout }
</script>

<script setup>
import { onMounted } from 'vue'
import { Head } from '@inertiajs/inertia-vue3'
import usePref from '@/Shared/usePref.js'

const props = defineProps({
  pref: Object,
})

onMounted(() => {
  usePref(props.pref)
})
</script>

<template>
  <div class="about philosopy">
    <Head title="自然と人の共存のために" />
    <div class="py-[50px] sm:py-[80px] md:py-[100px]">
      <!-- <h2 class="page-title text-afgreen">
        Sustainability
        <small>自然と人の共存のために</small>
      </h2> -->
      <div class="m-auto px-[calc(5vw_+_10px)] xs:px-[40px] sm:px-[60px] lg:px-0 max-w-[500px] sm:max-w-[800px]">
        <h2 class="mb-[30px] sm:mb-[40px] md:mb-[50px] lg:ml-[-80px]">
          <!-- <img class="mx-auto" src="https://img.aandf.co.jp/aandfcojp/img/corporate/philosophy_title.png" alt="自然と人の共存のために" /> -->
          <img class="mx-auto" src="/img/about/philosophy_title.png" alt="自然と人の共存のために" />
        </h2>

        <p class="text-center text-[3.5vw] xs:text-[14px] sm:text-[15px] md:text-[16px] leading-[2.4] mb-[50px] sm:mb-[60px] md:mb-[70px] lg:mb-[80px]">
          人も自然の一部です。<br class="sm:hidden" />豊かな自然なくして人の存在もありえません。<br />
          エイアンドエフは、<br class="sm:hidden" />より多くの人が母なる自然の営みに接し、<br />
          充実した生活と自然の大切さを<br class="sm:hidden" />学ぶことができるギアと機会を供給していきます。
        </p>

        <div class="mb-[60px]">
          <img class="mx-auto" src="https://img.aandf.co.jp/aandfcojp/img/corporate/philosophy_img.png" alt="自然と人の共存のために" />
        </div>

        <ul class="grid grid-cols-1 md:grid-cols-2 gap-[40px] sm:gap-[50px] md:gap-[60px] lg:gap-[70px] mb-[30px] [&_h4]:mb-[10px] xs:[&_h4]:mb-[15px] sm:[&_h4]:mb-[20px] [&_p]:leading-[2] sm:[&_p]:text-[110%] [&_img]:max-w-[300px] [&_img]:w-[70%] md[&_img]:w-auto">
          <li>
            <h4><img src="https://img.aandf.co.jp/aandfcojp/img/corporate/philosophy_txt1.png" alt="ギアと人をつなぐ" /></h4>
            <p>大自然に足を踏み入れたものだけが体験できる感動。エイアンドエフは、豊かなアウトドアライフのために、ギアの効用を伝えていきます。</p>
          </li>
          <li>
            <h4><img src="https://img.aandf.co.jp/aandfcojp/img/corporate/philosophy_txt2.png" alt="人とひとをつなぐ" /></h4>
            <p>より多くの人がアウトドアに親しみ、自然尊重の叡知を養うことを願う。エイアンドエフは、アウトドアの起点として、人と人との交流の場、人と人との出会いの場を供給していきます。</p>
          </li>
          <li>
            <h4><img src="https://img.aandf.co.jp/aandfcojp/img/corporate/philosophy_txt3.png" alt="ギアと自然をつなぐ" /></h4>
            <p>叡知を集め明るい未来を見つけることがわれわれ人間の使命。エイアンドエフは、自然と共存するために、常に良いギアを供給していきます。</p>
          </li>
          <li>
            <h4><img src="https://img.aandf.co.jp/aandfcojp/img/corporate/philosophy_txt4.png" alt="LIVE AND LET ME" /></h4>
            <p>自然と人・人と人とは持ちつ持たれつ。私たちエイアンドエフは、自然を大切にするとともに、私たちを取り巻く様々な関係者、取引先や顧客、地域社会の人々、とりわけ従業員を大切にします。</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
